export const init = function () {
  if (window.fby) {
    (function () {
      var f = document.createElement('script')
      f.type = 'text/javascript'
      f.async = true
      f.src = '//cdn.feedbackify.com/f.js'
      var s = document.getElementsByTagName('script')[0]
      s.parentNode.insertBefore(f, s)
    })()
  }
}
